<template>
	<div class="items-content">
		<div class="title">{{ showTitle }}</div>
		<div class="select-year" @click="showSelect">
			<div>
				{{selectYear}}
			</div>
		</div>
		<div class="list">
			<ul v-for="item in list" :key="item.id" class="list-ul">
				<li class="list-li">
					<span class="list-day">{{item.day}}</span>
					<span :class="{pdf: item.pdf}" class="list-title" @click="clickpdf(item.pdf)">{{item.title}}</span>
				</li>
			</ul>
			<page-turn :pageSum="pageSum" @on-turn="onTurn"></page-turn>
		</div>
		<comPicker :showPicker="showYearPicker" :pickerTitle="'年份选择'" :pickerList="pickerList" :selectPicker="selectYear" @closePicker="close" @confirmPicker="confirm"></comPicker>
	</div>
</template>

<script>
import ajax from "@/api/ajax";
import comPicker from '@/components/comSelector'
import pageTurn from "@/components/page-turn";
import { listTitle } from './config'
export default {
	name: "list-component",
	data() {
		return {
			list: [],
			selectYear: "",
			showYearPicker: false,
			pageNo: 1,
			pageSize: 5,
			pageSum: 1,
			cmsApi: '',
			pickerList: []
		};
	},
	components: {
		comPicker,
		pageTurn
	},
	computed: {
		showTitle() {
			return listTitle[this.cmsApi] || ''
		}
	},
	async created() {
		this.cmsApi = this.$route.meta.cmsApi
		const tempList = await this.getList();
		const data = [...new Set(tempList.map(item => item.day.slice(0, 4)))];
		this.pickerList = data.sort((a, b) => b - a)
		this.selectYear = data[0];
		this.conditioList(true);
	},
	methods: {
		/**
		 * 获取列表
		 * @return 返回列表
		 * @param selectYear 选择的某一年份
		 * @param pageNo 第几页
		 * @param pageSize 一页几个
		 */
		async getList(selectYear, pageNo, pageSize) {
			this.$loading('加载中')
			const params = {}
			if (selectYear) {
				params.day_lt = `${Number(selectYear) + 1}-01-01`;
				params.day_gte = `${selectYear}-01-01`;
			}
			if (pageNo && pageSize) {
				params._start = (pageNo - 1) * pageSize;
				params._limit = pageSize;
			}
			params._sort = 'day:DESC'
			const result = await ajax[this.cmsApi]({
				params
			});
			this.$loading()
			if (result) {
				return result;
			} else {
				return [];
			}
		},
		async conditioList(changeYear) {
			if (changeYear) {
				const tempList = await this.getList(this.selectYear);
				this.pageSum = Math.ceil(tempList.length / this.pageSize);
			}
			this.list = await this.getList(
				this.selectYear,
				this.pageNo,
				this.pageSize
			);
			window.scrollTo(0, 0);
		},
		showSelect() {
			this.showYearPicker = true;
		},
		confirm(val) {
			this.showYearPicker = false;
			this.selectYear = val;
			this.pageNo = 1;
			this.conditioList(true);
		},
		close() {
			this.showYearPicker = false;
		},
		onTurn(data) {
			this.pageNo = Number(data.page);
			this.conditioList();
		},
		clickpdf(pdf) {
			if(!pdf) return
			window.open(pdf.url)
		}
	}
};
</script>

<style lang="scss" scoped>
.items-content {
	.title {
		font-size: 0.44rem;
		color: #333333;
		font-weight: bold;
		text-align: center;
		margin: 0.6rem 0;
		background-color: #fff;
	}
	.select-year {
		display: flex;
		justify-content: flex-end;
		div {
			width: 2.5rem;
			height: .8rem;
			line-height: .8rem;
			margin-right: .2rem;
			background-color: #f1f1f1;
			text-align: center;
		}
	}
	.list{
		padding: 0 40px;
		margin-top: 100px;
		.list-ul {
			margin-bottom: 40px;
			.list-li {
			display: flex;
			align-items: flex-start;
			margin-bottom: 20px;
			.list-day {
				margin-right: 40px;
			}
			.list-title {
				flex: 1;
				&.pdf {
					text-decoration: underline;
					color: $red
				}
			}
		}
		}

	}
}
</style>



// WEBPACK FOOTER //
// src/pages/investorRelations/list.vue